import order from '../../../services/purchase/order.js';

export default {
    namespaced: false,
    state: {
        params: {
            state: 1
        },
        options: {},
        list: [],
        loading : false,
        length: 0
    },
    getters: {
        params: state => state.params,
        options: state => state.options,
        list: state => state.list,
        loading: state => state.loading,
        length: state => state.length
    },
    mutations: {
        setOptions: (state, payload) => state.options = payload,
        setParams: (state, payload) => state.params = payload,
        setList: (state, payload) => state.list = payload,
        setLoading: (state, payload) => state.loading = payload,
        setLength: (state, payload) => state.length = payload
    },
    actions: {
        updateOptions(context, payload) {
            context.commit("setOptions", payload);
            context.dispatch("search");
        },
        updateParams(context, payload) {
            context.commit("setParams", payload);
            context.dispatch("search");
        },
        search(context){
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                order.index({...context.state.options, ...context.state.params}).then(response => {
                    context.commit("setList", response.data.data)
                    context.commit("setLength", response.data.count)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                }).finally(() => context.commit("setLoading", false))
            })
        }
    }
}